import { render } from "./SensorFormComponent.vue?vue&type=template&id=608ec4dc"
import script from "./SensorFormComponent.vue?vue&type=script&lang=js"
export * from "./SensorFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__